/*
 * @Description: 新增Release组件，判断是否唯一子节点，是否展示逻辑关系
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-30 11:41:19
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-10 17:55:27
 */
import React from "react";
import { Popover, Select } from "antd";
import { useTranslation } from "react-i18next";
import { PlusOutlined, EllipsisOutlined } from "@ant-design/icons";
interface PropsType {
	isOneChild: boolean;
	selectedConjunction: string;
	setConjunction: (value: string) => void;
	setNot: (not: boolean) => void;
}

const groupActionsPositionList = {
	topLeft: "group--actions--tl",
	topCenter: "group--actions--tc",
	topRight: "group--actions--tr",
	bottomLeft: "group--actions--bl",
	bottomCenter: "group--actions--bc",
	bottomRight: "group--actions--br"
};
const Release: React.FC<PropsType> = props => {
	const { t } = useTranslation();
	/** 源组件的 */
	const { isOneChild = true, selectedConjunction, setConjunction, setNot } = props;

	/** 新加添加group的方法 */
	const { config, addRule, addGroup, removeSelf, setLock, isLocked, isTrueLocked, id, canAddGroup, canAddRule, canDeleteGroup } =
		props;

	const defaultPosition = "bottomLeft";

	const {
		immutableGroupsMode,
		addRuleLabel,
		addGroupLabel,
		delGroupLabel,
		groupActionsPosition,
		renderButton: Btn,
		renderSwitch: Switch,
		renderButtonGroup: BtnGrp,
		lockLabel,
		lockedLabel,
		showLock,
		canDeleteLocked
	} = config.settings;
	const position = groupActionsPositionList[groupActionsPosition || defaultPosition];

	const addRuleBtn = !immutableGroupsMode && canAddRule && !isLocked && (
		<Btn type="addRule" onClick={addRule} label={addRuleLabel} readonly={isLocked} config={config} />
	);
	const addGroupBtn = !immutableGroupsMode && canAddGroup && !isLocked && (
		<Btn type="addGroup" onClick={addGroup} label={addGroupLabel} readonly={isLocked} config={config} />
	);

	const delGroupBtn = !immutableGroupsMode && canDeleteGroup && (!isLocked || (isLocked && canDeleteLocked)) && (
		<Btn type="delGroup" onClick={removeSelf} label={delGroupLabel} config={config} />
	);

	// if (isOneChild) {
	// 	return;
	// } else {
	// 	return (
	// 		<div className="release-container">
	// 			{/* <Select
	// 				showArrow={true}
	// 				style={{ width: 70 }}
	// 				size={"middle"}
	// 				defaultValue={selectedConjunction || "AND"}
	// 				options={[
	// 					{
	// 						value: "AND",
	// 						label: t("AND")
	// 					},
	// 					{
	// 						value: "OR",
	// 						label: t("OR")
	// 					}
	// 					// {
	// 					//     value: "NOT",
	// 					//     label: intl.formatMessage({id:'NOT'})
	// 					// }
	// 				]}
	// 				onChange={onChange}
	// 			/> */}

	// 			<div className="release_check_release">
	// 				<Popover
	// 					content={
	// 						<div className={`group--actions ${position}`}>
	// 							<BtnGrp config={config}>
	// 								{/* {setLockSwitch} */}
	// 								{addRuleBtn}
	// 								{addGroupBtn}
	// 								{/* {delGroupBtn} */}
	// 							</BtnGrp>
	// 						</div>
	// 					}
	// 				>
	// 					<EllipsisOutlined />
	// 				</Popover>
	// 			</div>
	// 			<div className="release">AND</div>
	// 			<div className="release_add_rule">
	// 				<Popover
	// 					style={{ width: 200 }}
	// 					placement="right"
	// 					content={
	// 						<div className={`group--actions ${position}`}>
	// 							<BtnGrp config={config}>
	// 								{/* {setLockSwitch} */}
	// 								{addRuleBtn}
	// 								{addGroupBtn}
	// 								{/* {delGroupBtn} */}
	// 							</BtnGrp>
	// 						</div>
	// 					}
	// 				>
	// 					<PlusOutlined />
	// 				</Popover>
	// 			</div>
	// 		</div>
	// 	);
	// }

	/** 去除单个子节点判断 */

	return (
		<div className={`release-container release_${selectedConjunction}`}>
			<div className="release_check_release">
				<Popover placement="right" content={<div className="deleteGroup">{delGroupBtn}</div>}>
					{canDeleteGroup && <EllipsisOutlined />}
				</Popover>
			</div>
			<div
				className="release"
				onClick={() => {
					if (selectedConjunction === "AND") {
						setConjunction("OR");
					} else {
						setConjunction("AND");
					}
				}}
			>
				{selectedConjunction || "AND"}
			</div>
			<div className="release_add_rule">
				<Popover
					style={{ width: 200 }}
					placement="right"
					content={
						<div className={`group--actions ${position}`}>
							<BtnGrp config={config}>
								{/* {setLockSwitch} */}
								{addRuleBtn}
								{addGroupBtn}
								{/* {delGroupBtn} */}
							</BtnGrp>
						</div>
					}
				>
					<PlusOutlined />
				</Popover>
			</div>
		</div>
	);
};

export default Release;
